<template>
  <div class="min-h-[100vh]">
    <NuxtLoadingIndicator />
    <AppHeader />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <AppDrawer />
    <AppFooter />
  </div>
</template>

<script setup>
const app = useAppStore()
const route = useRoute()

// Add initial page view
onMounted(() => {
  app.addPageview()
})

// Increment page views in config
watch(() => route.query, () => {
  app.addPageview()
})

// Toggle no-scroll class on body
useHead({
  bodyAttrs: {
    class: computed(() => app.lockScroll ? 'no-scroll' : '')
  }
})
</script>
